import { curry, prop, join, compose } from 'ramda';
import { getLocalizedState } from './i18n';

export const getDocByIdError = curry((id, state) =>
  compose(
    prop(id),
    getLocalizedState(state),
    prop('loadDocById'),
    prop('errors')
  )(state)
);

export const getDocByUidError = curry((type, uid, state) =>
  compose(
    prop(`${type}-${uid}`),
    getLocalizedState(state),
    prop('loadDocByUid'),
    prop('errors')
  )(state)
);

export const getDocsByIdsError = curry((ids, state) =>
  compose(
    prop(join(',', ids)),
    getLocalizedState(state),
    prop('loadDocByIds'),
    prop('errors')
  )(state)
);

export const getSingleTypeDocError = curry((type, state) =>
  compose(
    prop(type),
    getLocalizedState(state),
    prop('loadDocByType'),
    prop('errors')
  )(state)
);

export const getDocError = curry((key, state) =>
  compose(
    prop(key),
    getLocalizedState(state),
    prop('loadDoc'),
    prop('errors')
  )(state)
);

export const getDocsError = curry((key, state) =>
  compose(
    prop(key),
    getLocalizedState(state),
    prop('loadDocs'),
    prop('errors')
  )(state)
);

export const getGlobalError = (state) =>
  compose(prop('global'), prop('errors'))(state);
